import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { prepareHeaders } from "../user/user.api";
import { PaginationResults, TypeQuery } from "../user/user.type";
import { ApiBaseUrl } from "../../http";
import { IDashboard } from "./dashboard.type";
import { QueryUrl } from "../../Utils";
import { IMission } from "../mission/mission.type";

const DashboardApi = createApi({
  reducerPath: "dashboardApi",
  tagTypes: ["dashboard", "dashboardPrestation"],
  baseQuery: fetchBaseQuery({
    baseUrl: `${ApiBaseUrl}/api/`,
    prepareHeaders,
  }),
  endpoints: (build) => ({
    getDashboardOverwiewData: build.query<IDashboard, TypeQuery>({
        query: (query) => QueryUrl("dashboard", query),
        providesTags: ["dashboard"],
    }),
    getDashboardPrestationData: build.query<PaginationResults<IMission>, TypeQuery>({
        query: (query) => QueryUrl("dashboard", query),
        providesTags: ["dashboardPrestation"],
    }),
  }),
});

export default DashboardApi;

export const { useGetDashboardOverwiewDataQuery, useGetDashboardPrestationDataQuery } =
  DashboardApi;
